export enum PaymentMethodConfigTypes {
  SWISH_TRADE = 'SWISH_TRADE',
  SWISH_COMPANY = 'SWISH_COMPANY',
  SWISH_TEST = 'SWISH_TEST',
  SWISH = 'SWISH_COMPANY',
  STRIPE = 'STRIPE',
  CASH = 'CASH',
  EXTERNAL_CARD_MACHINE = 'EXTERNAL_CARD_MACHINE',
  TIDYPAY = 'TIDYPAY',
  OTHER = 'OTHER',
  BANK_TRANSFER = 'BANK_TRANSFER',
  SWISH_PAYOUT = 'SWISH_PAYOUT',
  TERMINAL = 'TERMINAL',
  NETS_TERMINAL = 'NETS_TERMINAL',
  VIVA_WALLET = 'VIVA_WALLET',
  VIVA_WALLET_TERMINAL = 'VIVA_WALLET_TERMINAL',
  SOFTPAY = 'SOFTPAY',
  FORTNOX_INVOICE = 'FORTNOX_INVOICE',
  GIFT_CARD = 'GIFT_CARD',
  VIVA_WALLET_WEB = 'VIVA_WALLET_WEB',
}

export const DefaultNamesForPaymentMethodConfigTypes = {
  [PaymentMethodConfigTypes.SWISH_TRADE]: 'Swish handel',
  [PaymentMethodConfigTypes.SWISH_COMPANY]: 'Swish företag',
  [PaymentMethodConfigTypes.SWISH]: 'Swish företag',
  [PaymentMethodConfigTypes.SWISH_PAYOUT]: 'Swish Payout',
  [PaymentMethodConfigTypes.SWISH_TEST]: 'Swish test',
  [PaymentMethodConfigTypes.STRIPE]: 'Stripe Kort',
  [PaymentMethodConfigTypes.CASH]: 'Kontant',
  [PaymentMethodConfigTypes.EXTERNAL_CARD_MACHINE]: 'Extern kortmaskin',
  [PaymentMethodConfigTypes.TIDYPAY]: 'Tidypay',
  [PaymentMethodConfigTypes.BANK_TRANSFER]: 'Banköverföring',
  [PaymentMethodConfigTypes.OTHER]: 'Annat',
  [PaymentMethodConfigTypes.TERMINAL]: 'Terminal',
  [PaymentMethodConfigTypes.NETS_TERMINAL]: 'Nets Terminal',
  [PaymentMethodConfigTypes.VIVA_WALLET]: 'Viva.com',
  [PaymentMethodConfigTypes.VIVA_WALLET_TERMINAL]: 'Viva.com Terminal',
  [PaymentMethodConfigTypes.SOFTPAY]: 'Softpay',
  [PaymentMethodConfigTypes.FORTNOX_INVOICE]: 'Fortnox Faktura',
  [PaymentMethodConfigTypes.GIFT_CARD]: 'Presentkort',
  [PaymentMethodConfigTypes.VIVA_WALLET_WEB]: 'Viva.com Web',
};

export const DefaultShortNamesForPaymentMethodConfigTypes = {
  [PaymentMethodConfigTypes.SWISH_TRADE]: 'Handel',
  [PaymentMethodConfigTypes.SWISH_COMPANY]: 'Företag',
  [PaymentMethodConfigTypes.SWISH]: 'Företag',
  [PaymentMethodConfigTypes.SWISH_PAYOUT]: 'Payout',
  [PaymentMethodConfigTypes.SWISH_TEST]: 'Test',
  [PaymentMethodConfigTypes.STRIPE]: 'Stripe',
  [PaymentMethodConfigTypes.CASH]: 'Kontant',
  [PaymentMethodConfigTypes.EXTERNAL_CARD_MACHINE]: 'Extern',
  [PaymentMethodConfigTypes.TIDYPAY]: 'Tidypay',
  [PaymentMethodConfigTypes.BANK_TRANSFER]: 'Banköverföring',
  [PaymentMethodConfigTypes.OTHER]: 'Annat',
  [PaymentMethodConfigTypes.TERMINAL]: 'Terminal',
  [PaymentMethodConfigTypes.NETS_TERMINAL]: 'Nets',
  [PaymentMethodConfigTypes.VIVA_WALLET]: 'Viva',
  [PaymentMethodConfigTypes.VIVA_WALLET_TERMINAL]: 'Viva terminal',
  [PaymentMethodConfigTypes.SOFTPAY]: 'Softpay',
  [PaymentMethodConfigTypes.FORTNOX_INVOICE]: 'Fortnox',
  [PaymentMethodConfigTypes.GIFT_CARD]: 'Presentkort',
  [PaymentMethodConfigTypes.VIVA_WALLET_WEB]: 'Viva.com Web',
};
